import { ALButton, ALLink } from "../ALComponents";
import useResponsiveWithHydrationFix from "../../hooks/useResponsiveWithHydrationFix";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import * as lpSimpleBlocStyles from "./lpSimpleBlock/lpSimpleBlocStyles.module.scss";

function LPSimpleBloc({ content, componentType }) {
  const additionalClassName = componentType
    ? `${lpSimpleBlocStyles[componentType.toLowerCase()]}`
    : "";

  if (content) {
    return (
      <div
        className={`${lpSimpleBlocStyles.container} ${additionalClassName} id-${content.contentful_id}`}
      >
        <div
          style={{
            backgroundColor: content?.backgroundColor || "#69998C",
            color: content?.textColor || "#FFF",
          }}
          className={lpSimpleBlocStyles.content}
        >
          {content?.title !== "null" && (
            <h2
              className={`${lpSimpleBlocStyles.content_title} ${useResponsiveWithHydrationFix(
                "h3",
                "h2"
              )}`}
            >
              {content?.title}
            </h2>
          )}
          {content?.subtitle !== "null" && (
            <p className={`${lpSimpleBlocStyles.content_subtitle} al_p`}>{content?.subtitle}</p>
          )}
          <div className={lpSimpleBlocStyles.buttons}>
            {content?.buttons.map((b, i) => (
              <ALLink key={i} to={b?.link?.link} className={lpSimpleBlocStyles.buttons_link}>
                <ALButton
                  buttonBackgroundColor={content?.buttonColors?.buttonBackgroundColor || "#000"}
                  buttonTextColor={content?.buttonColors?.buttonColor || "#FFF"}
                  fullWidth
                >
                  {b?.title}
                </ALButton>
              </ALLink>
            ))}
          </div>
        </div>
      </div>
    );
  }
  return null;
}

export default withALErrorBoundary({
  name: "LPSimpleBloc",
  priority: "P3",
})(LPSimpleBloc);
